export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/vertical_page_perseus/placeholder_image.a7175a3.png";